import { ReactElement } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "@/modules/auth/hooks/use-auth"
import { AppRole } from "@/modules/auth/constants/app-role"

interface GuestRouteProps {
  children?: ReactElement
}

function resolveRoleRedirect(hasRole: (role: AppRole | AppRole[]) => boolean): string {
  if (hasRole(AppRole.Employee)) return "/employee/dashboard"
  return "/dashboard"
}

export function GuestRoute({ children }: GuestRouteProps) {
  const { isAuthenticated, hasRole } = useAuth()

  if (isAuthenticated) {
    return <Navigate to={resolveRoleRedirect(hasRole)} replace />
  }

  return children ?? <Outlet />
}
